/* Atelier - product page behaviour.

   Three jobs, all additive to Dawn's own product form:
     1. A mobile sticky buy bar that mirrors the real add-to-cart button, so the CTA is
        reachable on a page that can run several thousand pixels tall.
     2. Reveal-on-scroll for the below-fold blocks.
     3. Thumbnail rail sync, so the active thumbnail scrolls into view on variant change.

   It never submits the cart itself. The bar clicks Dawn's real submit button, which keeps
   variant state, inventory rules, cart drawer behaviour and every app that listens on that
   form intact.

   The bar's visibility used to be driven by a single IntersectionObserver created once at
   DOMContentLoaded. Measured at 375x812: the real CTA sat at y=1093 on an 812px viewport -
   plainly off screen - and the bar stayed hidden through a full scroll of the page, while
   an identical observer created by hand a moment later worked immediately. One lookup, made
   once, against a form that apps on this store re-render. It is now resolved on every
   update and driven by the scroll position, which cannot miss an event it was not around
   for. */
(function () {
  'use strict';

  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* The bare form selector matches an app's cart form that carries no submit button and
     comes first in the document, so the product form is always asked for by name first. */
  function form() {
    return document.querySelector('product-form form[action*="/cart/add"]')
        || document.querySelector('form[action*="/cart/add"]');
  }

  function submitButton() {
    var f = form();
    return f ? f.querySelector('[type="submit"]') : null;
  }

  /* ------------------------------------------------------- mobile buy bar -- */

  function initBar() {
    var host = document.querySelector('[data-pdp-bar]');
    if (!host) return;

    var cta = host.querySelector('[data-pdp-bar-cta]');
    var priceOut = host.querySelector('[data-pdp-bar-price]');
    if (!cta) return;

    var bound = null;

    function mirror(real) {
      var disabled = real.hasAttribute('disabled');
      cta.disabled = disabled;
      cta.textContent = disabled ? 'Sold out' : 'Add to cart';

      var live = document.querySelector('.product__info-container .price-item--sale, .product__info-container .price-item--regular');
      if (live && priceOut) priceOut.textContent = live.textContent.trim();
    }

    /* Rebinding rather than assuming: if an app swaps the form out, the next update picks
       up the new button instead of watching a detached one. */
    function bind(real) {
      if (real === bound) return;
      bound = real;
      mirror(real);
      new MutationObserver(function () { mirror(real); })
        .observe(real, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    function update() {
      var real = submitButton();
      if (!real) return;
      bind(real);

      var r = real.getBoundingClientRect();
      /* 60px of slack at the bottom, so the bar does not flash in while the real button is
         still effectively on screen. */
      var onScreen = r.top < (window.innerHeight - 60) && r.bottom > 0;
      host.classList.toggle('is-in', !onScreen);
    }

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        update();
      });
    }

    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      var real = submitButton();
      if (real && !cta.disabled) real.click();
    });

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    var priceBlock = document.querySelector('.product__info-container .price');
    if (priceBlock) {
      new MutationObserver(schedule).observe(priceBlock, { childList: true, subtree: true, characterData: true });
    }

    update();
    /* The page keeps growing for a few seconds while apps inject their widgets, which moves
       the real button. These re-check without leaving a timer running. */
    [300, 900, 2000, 5000].forEach(function (ms) { window.setTimeout(update, ms); });
  }

  /* ------------------------------------------------------------- reveals --- */

  function initReveal() {
    var els = document.querySelectorAll('.gf-pdp-rv');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      [].forEach.call(els, function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    [].forEach.call(els, function (e) { io.observe(e); });
  }

  /* ---------------------------------------------------------- thumb rail --- */

  function initThumbs() {
    var list = document.querySelector('.thumbnail-slider .thumbnail-list');
    if (!list) return;
    function follow() {
      var active = list.querySelector('.thumbnail[aria-current]');
      if (!active) return;
      var item = active.closest('.thumbnail-list__item') || active;
      var l = item.offsetLeft - (list.clientWidth / 2) + (item.clientWidth / 2);
      list.scrollTo({ left: Math.max(0, l), behavior: reduced ? 'instant' : 'smooth' });
    }
    new MutationObserver(follow).observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
  }

  function init() { initBar(); initReveal(); initThumbs(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();